/**
 * Buyer-facing auction pricing (public listing / bid UI).
 * Base price is the starting/opening price. Reserve price is never shown to buyers.
 */

export const toAuctionMoney = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const getBuyerStartingPrice = (auction) => {
  if (!auction) return 0;
  const base = toAuctionMoney(auction.base_price ?? auction.expected_price);
  return base > 0 ? base : 0;
};

export const getBuyerHighestBidAmount = (auction) => {
  if (!auction) return null;
  const fromListing = toAuctionMoney(auction.highest_bid_amount);
  if (fromListing > 0) return fromListing;
  const fromRelated = toAuctionMoney(auction.highest_bid);
  if (fromRelated > 0) return fromRelated;
  return null;
};

export const hasBuyerBids = (auction) => getBuyerHighestBidAmount(auction) != null;

export const isBuyerAuctionReserveMet = (auction) =>
  auction?.reserve_price_reached === "Y" || auction?.reserve_price_reached === "y";

export const getBuyerMinNextBid = (auction, highestBidFromBids = null) => {
  if (!auction) return 0;
  const increment = toAuctionMoney(auction.bid_increment);
  const highestFromBids =
    highestBidFromBids?.bid_amount != null
      ? toAuctionMoney(highestBidFromBids.bid_amount)
      : null;
  const highest =
    highestFromBids != null && highestFromBids > 0
      ? highestFromBids
      : getBuyerHighestBidAmount(auction);

  if (highest != null && highest > 0) {
    return highest + increment;
  }

  const openingBase = getBuyerStartingPrice(auction);
  return openingBase + increment;
};
